import React from "react";
import profilpic from "../assets/media/profilpic.png";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { IconButton } from "@mui/material";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import logo from "../assets/media/mby-high-resolution-logo-transparent .png";
import { FaMedium } from "react-icons/fa";
import { Helmet } from "react-helmet";

const About = () => {
  return (
    <div className="about">
      <Helmet>
        <title>AboutPage | Blogia</title>
        <meta name="description" content="about page  description" />
      </Helmet>
      <div
        className="aboutCircle"
        style={{ margin: "auto", width: "50%", marginBottom: "2rem" }}
      >
        <img
          style={{
            margin: "auto",

            borderRadius: "20px",
            boxShadow: "-3px 3px 3px 5px rgba(255,255,255,0.5)",
          }}
          width="500px"
          height="500px"
          src={profilpic}
          alt=""
        />
      </div>
      <div
        className="aboutTitle aboutCircle"
        style={{
          width: "500px",
          backgroundImage:
            "linear-gradient( 358.7deg,  rgba(42,136,157,1) 1.7%, rgba(122,197,214,1) 51.1%, rgba(211,232,242,1) 95.5% )",
          margin: "auto",
          marginTop: "1rem",
          padding: "1rem",
          borderRadius: "20px",
          fontFamily: "Poppins",
          paddingBottom: ".7rem",
          opacity: ".9",
          boxShadow: "3px 3px 3px 5px rgba(255,255,255,0.5)",
        }}
      >
        {" "}
        <p style={{ marginBottom: ".6rem" }}>
          As a Frontend Developer with over 2 years of experience, I specialize
          in MERN Stack development, proficient in JavaScript and Python. I
          excel in building modern web applications using MongoDB, React,
          Express, and Node.js. On the frontend, I leverage tools like Redux,
          Redux Toolkit, and Formik, while on the backend, I craft reliable APIs
          using Node.js and Express.js. My curiosity for technology and
          solution-oriented approach drive me to continually acquire new skills,
          while my attention to detail ensures the delivery of high-quality
          solutions.
        </p>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <IconButton>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://github.com/M-Burak-Yilmazer"
              >
                <FaGithub color="#EDBDAC" />
              </a>
            </IconButton>
            <IconButton>
              <a
                target="_blank"
                href="https://www.linkedin.com/in/muhittin-burak-yilmazer-9a576b1aa/"
                rel="noreferrer"
              >
                <FaLinkedin color="#EDBDAC" />
              </a>
            </IconButton>
            <IconButton>
              <a
                target="_blank"
                href="https://twitter.com/mathias03521682"
                rel="noreferrer"
              >
                <FaSquareXTwitter color="#EDBDAC" />
              </a>
            </IconButton>
            <IconButton>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.instagram.com/juniorinho_muti?igsh=NDNhbzcyeThlMnVv "
              >
                <FaInstagram color="#EDBDAC" />
              </a>
            </IconButton>
            <IconButton>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://medium.com/@mbyilmazer38"
              >
                <FaMedium color="#EDBDAC" />
              </a>
            </IconButton>
          </div>
          <div>
            <img style={{ width: "100px" }} src={logo} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
